import { useTheme } from "../hooks/use-theme";
import { Bell, ChevronsLeft, Moon, Search, Sun } from "lucide-react";
import profileImg from "../assets/user.png";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom"; 
import axios from "axios";
import config from "../../config";

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
export const Header = ({ collapsed, setCollapsed }) => {
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate(); 

  const handleLogout = async () =>{
    try{
      // 1. call backend logout ApI if you have one
      await axios.post(`${config.baseURL}/logout`, {}, {
        headers: {
          "Content-Type": "Application/json",
          // INclude any auth token if needed
        }
      });
      // 2. clear all client-side auth storage
      localStorage.removeItem('isAdminLoggedIn');

      navigate("/admin/login");
      window.location.reload();
    }catch(error){
      console.error("Logout failed:", error);
      localStorage.removeItem("isAdminLoggedIn");
      navigate("/admin/login");
    }
  };

  return (
    <header className="relative z-10 flex h-[60px] items-center justify-between bg-white px-4 shadow-md transition-colors dark:bg-slate-900">
      <div className="flex items-center gap-x-3">
        <button
          className="btn-ghost size-10"
          onClick={() => setCollapsed(!collapsed)}
        >
          <ChevronsLeft className={collapsed && "rotate-180"} />
        </button>
        <div className="input">
          <Search size={20} className="text-slate-300" />
          <input
            type="text"
            name="search"
            id="search"
            placeholder="Search..."
            className="w-full bg-transparent text-slate-900 outline-0 placeholder:text-slate-300 dark:text-slate-50"
          />
        </div>
      </div>
      <div className="flex items-center gap-x-3">
        <button
          className="btn-ghost size-10"
          onClick={() => setTheme(theme === "light" ? "dark" : "light")}
        >
          <Sun size={20} className="dark:hidden" />
          <Moon size={20} className="hidden dark:block" />
        </button>
        <button className="btn-ghost size-10">
          <Bell size={20} />
        </button>
        <Popover className="relative ">
          <PopoverButton className="size-10 overflow-hidden rounded-full border">
            <img
              src={profileImg}
              alt="profile"
              className="size-full object-cover"
            />
          </PopoverButton>
          <PopoverPanel
            transition
            className="absolute right-[-40%] z-10 mt-5 flex w-screen max-w-[20rem] -translate-y-[1%] px-4 transition data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150 data-[enter]:ease-out data-[leave]:ease-in"
          >
            <div className=" card w-screen max-w-md flex-auto overflow-hidden rounded-1xl bg-white text-sm/6 shadow-lg ring-1 ring-gray-900/5 dark:bg-slate-900">
              <div className="p-2">
                {/* Directly render the logout button */}
                <button
                  onClick={handleLogout}
                  className="btn-ghost w-full text-left underline font-semibold"
                >
                  Logout
                  <span aria-hidden="true">&rarr;</span>
                </button>
              </div>
            </div>
          </PopoverPanel>
        </Popover>
      </div>
    </header>
  );
};

Header.propTypes = {
  collapsed: PropTypes.bool,
  setCollapsed: PropTypes.func,
};